import { render, staticRenderFns } from "./resourceProjects.vue?vue&type=template&id=070dc80e&"
import script from "./resourceProjects.vue?vue&type=script&lang=js&"
export * from "./resourceProjects.vue?vue&type=script&lang=js&"
import style0 from "./resourceProjects.less?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070dc80e')) {
      api.createRecord('070dc80e', component.options)
    } else {
      api.reload('070dc80e', component.options)
    }
    module.hot.accept("./resourceProjects.vue?vue&type=template&id=070dc80e&", function () {
      api.rerender('070dc80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/resources/components/resourceCardProjects/resourceProjects.vue"
export default component.exports